module.exports = __webpack_public_path__ + "img/Airbnb-Work-From-Home-Home-Essentials-.b4bc4f2d.jpg";